module.exports = __webpack_public_path__ + "static/media/FBTLogo.23867163.svg";